<template>
  <div class="body__form--subscription">
    <div class="subscription__section">
      <div class="hide__subscription-section">
        <div class="card">
          <div class="card-body">
            <div class="step__voyage">
              <div class="step__voyage--item">
                <div
                  class="custom__badge_default"
                  :class="step === 1 ? 'custom__badge--active' : ''"
                >
                  1
                </div>
                <div
                  class="badge__text"
                  :class="step === 1 ? 'badge__text--active--active' : ''"
                >
                  Informations
                </div>
              </div>
              <hr />
              <div class="step__voyage--item">
                <div
                  class="custom__badge_default"
                  :class="step === 2 ? 'custom__badge--active' : ''"
                >
                  2
                </div>
                <div
                  class="badge__text"
                  :class="step === 2 ? 'badge__text--active--active' : ''"
                >
                  Fichiers joints
                </div>
              </div>
              <hr />
              <div class="step__voyage--item">
                <div
                  class="custom__badge_default"
                  :class="step === 3 ? 'custom__badge--active' : ''"
                >
                  3
                </div>
                <div
                  class="badge__text"
                  :class="step === 3 ? 'badge__text--active--active' : ''"
                >
                  Résultat
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div>
        <div class="card">
          <div class="card-body">
            <div class="custom__badge-section d-md-none">
              <div
                class="custom__badge_default"
                :class="step === 1 ? 'custom__badge--active' : ''"
              >
                1
              </div>
              <div
                class="custom__badge_default"
                :class="step === 2 ? 'custom__badge--active' : ''"
              >
                2
              </div>
              <div
                class="custom__badge_default"
                :class="step === 3 ? 'custom__badge--active' : ''"
              >
                3
              </div>
            </div>
            <h4 class="mb-4">{{ titleStep() }}</h4>
            <div v-if="step === 1">
              <div class="row">
                <div class="col-md-9 col-12">
                  <div class="form-check">
                    <label
                      @click="changeType()"
                      class="form-check-label form__label"
                    >
                      <input
                        type="radio"
                        v-model="form.data.type_engin"
                        class="form-check-input"
                        value="1"
                        name="materiel"
                      />Véhicules à 4 roues
                    </label>
                    <label class="form-check-label ml-5 form__label">
                      <input
                        type="radio"
                        v-model="form.data.type_engin"
                        class="form-check-input"
                        value="2"
                        name="materiel"
                      />Véhicules à 2 ou 3 roues
                    </label>
                  </div>
                </div>
              </div>
              <div class="row mt-2">
                <div class="col-md-6 col-12">
                  <div class="form-group">
                    <label class="form__label">Type d’usage du véhicule</label>
                    <select
                      @change="getPuissance()"
                      v-model="form.data.use_type"
                      class="form-control"
                    >
                      <option value="">Selectionner</option>
                      <option
                        v-for="(item, key) in useTypes"
                        :key="key"
                        :value="item.id"
                      >
                        {{ item.name }}
                      </option>
                    </select>
                    <div v-if="errors.use_type" style="color: red">
                      {{ errors.use_type[0] }}
                    </div>
                  </div>
                </div>
                <div class="col-md-6 col-12">
                  <div class="form-group">
                    <label class="form__label">Taille du cylindre</label>
                    <select v-model="form.data.power_id" class="form-control">
                      <option value="">Selectionner</option>
                      <option
                        v-for="(item, key) in puissance"
                        :key="key"
                        :value="item.id"
                      >
                        {{ item.name }}
                      </option>
                    </select>
                    <div v-if="errors.power_id" style="color: red">
                      {{ errors.power_id[0] }}
                    </div>
                  </div>
                </div>
              </div>
              <div class="row mt-2">
                <div class="col-md-6 col-12">
                  <div class="form-group">
                    <label class="form__label">Durée de l’abonnement</label>
                    <select
                      v-model="form.data.duration_of_insurance"
                      class="form-control"
                    >
                      <option value="">Selectionner</option>
                      <option
                        v-for="(item, key) in durations"
                        :key="key"
                        :value="item.id"
                      >
                        {{ item.name }}
                      </option>
                    </select>
                    <div v-if="errors.duration_of_insurance" style="color: red">
                      {{ errors.duration_of_insurance[0] }}
                    </div>
                  </div>
                </div>
                <div class="col-md-6 col-12">
                  <div class="form-group">
                    <label class="form__label">Valeurs Vénal</label>
                    <input
                      v-model="form.data.valeur_venal"
                      type="text"
                      class="form-control"
                    />
                    <div v-if="errors.valeur_venal" style="color: red">
                      {{ errors.valeur_venal[0] }}
                    </div>
                  </div>
                </div>
              </div>
              <div class="row mt-2">
                <div class="col-md-6 col-12">
                  <div class="form-group">
                    <label class="form__label">Valeur neuve</label>
                    <input
                      v-model="form.data.valeur_neuve"
                      type="number"
                      class="form-control"
                    />
                    <div v-if="errors.valeur_neuve" style="color: red">
                      {{ errors.valeur_neuve[0] }}
                    </div>
                  </div>
                </div>
                <div class="col-md-6 col-12">
                  <div class="form-group">
                    <label class="form__label">Nombres de places</label>
                    <input
                      v-model="form.data.number_of_seats_in_the_vehicle"
                      type="number"
                      class="form-control"
                    />
                    <div
                      v-if="errors.number_of_seats_in_the_vehicle"
                      style="color: red"
                    >
                      {{ errors.number_of_seats_in_the_vehicle[0] }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div v-show="step === 2">
              <p>
                Veuillez charger le(s) fichier(s) requis :
                <span style="color: #d09a12">copie de la carte grise.</span>
              </p>
              <file-upload
                ref="upload"
                :acceptFile="'.jpg,.png,.gif,.jpeg,.pdf,.doc,.docx,.xls,.xlsx'"
              />
            </div>
            <div v-if="step === 3">
              <div class="detail__sup">
                <div class="section__information">
                  <div class="section__information-text">Prime nette</div>
                  <div class="section__information-dote"></div>
                  <div class="section__information-price">
                    {{ $format(summary.amount) + " Fcfa" }}
                  </div>
                </div>
                <div class="section__information">
                  <div class="section__information-text">Coût de pièce</div>
                  <div class="section__information-dote"></div>
                  <div class="section__information-price">
                    {{ $format(summary.avenant) + " Fcfa" }}
                  </div>
                </div>
                <div class="section__information">
                  <div class="section__information-text">Taxe</div>
                  <div class="section__information-dote"></div>
                  <div class="section__information-price">
                    {{ $format(summary.taxe) + " Fcfa" }}
                  </div>
                </div>
                <div class="section__amount">
                  <div class="section__amount-text">Total</div>
                  <div class="section__amount-price">
                    {{ $format(summary.total) + " Fcfa" }}
                  </div>
                </div>
              </div>
              <div class="section__neg" @click="saveNegotiated()">
                <svg
                  width="19"
                  height="20"
                  viewBox="0 0 19 20"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M9.50065 2.57255C5.35851 2.57255 2.00065 5.93041 2.00065 10.0725C2.00065 14.2147 5.35851 17.5725 9.50065 17.5725C13.6428 17.5725 17.0006 14.2147 17.0006 10.0725C17.0006 5.93041 13.6428 2.57255 9.50065 2.57255ZM0.333984 10.0725C0.333984 5.00994 4.43804 0.905884 9.50065 0.905884C14.5633 0.905884 18.6673 5.00994 18.6673 10.0725C18.6673 15.1352 14.5633 19.2392 9.50065 19.2392C4.43804 19.2392 0.333984 15.1352 0.333984 10.0725Z"
                    fill="#002A85"
                  />
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M9.50065 9.23922C9.96089 9.23922 10.334 9.61231 10.334 10.0725V13.4059C10.334 13.8661 9.96089 14.2392 9.50065 14.2392C9.04041 14.2392 8.66732 13.8661 8.66732 13.4059V10.0725C8.66732 9.61231 9.04041 9.23922 9.50065 9.23922Z"
                    fill="#002A85"
                  />
                  <path
                    d="M10.334 6.73922C10.334 7.19945 9.96089 7.57255 9.50065 7.57255C9.04041 7.57255 8.66732 7.19945 8.66732 6.73922C8.66732 6.27898 9.04041 5.90588 9.50065 5.90588C9.96089 5.90588 10.334 6.27898 10.334 6.73922Z"
                    fill="#002A85"
                  />
                </svg>
                <span class="section__neg-text">Demander une négociation</span>
              </div>
            </div>
          </div>
          <div class="card-footer">
            <div class="button__footer">
              <button
                @click="prevStep()"
                :disabled="step === 1"
                class="btn btn-default__cancel mr-2"
              >
                Retour
              </button>
              <button
                :class="loading ? 'disabled' : ''"
                class="btn btn-primary__save"
                @click="saveAssurance()"
              >
                {{ getText() }}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import FileUpload from "../../../../../components/upload/FileUpload.vue";
import { api } from "../../../../../helpers/shared";
let loader = null;
export default {
  name: "moto",
  props: ["subscription"],
  components: { FileUpload },
  watch: {
    step: function (val) {
      this.form.step = val;
    },
  },
  data: () => ({
    errors: [],
    step: 1,
    element: 0,
    loading: false,
    useTypes: [
      { name: "Personnel", id: 1 },
      { name: "Taxi", id: 2 },
    ],
    summary: {
      amount: 0,
      avenant: 2000,
      taxe: 0,
      total: 0,
    },
    puissance: [],
    durations: [],
    surprime: [],
    form: {
      amount: "",
      product_id: 1,
      step: 1,
      data: {
        type_engin: "2",
        fuel_id: "",
        power_id: "",
        category_id: "",
        sub_category_id: "",
        use_type: "",
        semi_remorque: false,
        domage: false,
        duration_of_insurance: "",
        number_of_seats_in_the_vehicle: "",
        name: "",
        email: "",
        address: "",
        phone: "",
        valeur_venal: "",
        valeur_neuve: "",
        person_to_contact: "",
        telephone_number: "",
        vehicle_registration_card: "",
        list_of_guarantees: [],
      },
    },
  }),
  mounted() {
    this.initializeForm(this.subscription);
  },
  methods: {
    initializeForm(element) {
      let { amount, data, product_id, step } = element;
      if (data.type_engin == "2") {
        this.form.step = step;
        this.form.amount = amount;
        this.form.product_id = product_id;
        this.form.data = data;
        this.getPuissance();
        this.getDurations();
      }
    },

    showTooltips(text) {
      this.$document(".tooltips_n").tooltip({
        title: text,
        trigger: "click",
        placement: "top",
      });
    },

    nextStep() {
      if (this.step < 3) this.step++;
      if (this.step === 2) {
        this.$refs.upload.reloadView();
      }
    },
    prevStep() {
      if (this.step !== 1) this.step--;
      if (this.step === 2) {
        this.$refs.upload.reloadView();
      }
    },
    titleStep() {
      if (this.step === 1) {
        return "Informations";
      } else if (this.step === 2) {
        return "Fichiers joints";
      } else return "Résultat";
    },
    getText() {
      switch (this.step) {
        case 1:
          return "Suivant";
          break;
        case 2:
          return "Suivant";
          break;
        case 3:
          return "Ajouter au panier";
      }
    },

    saveNegotiated() {
      if (this.step == "2") {
        loader = this.$loading.show({
          container: null,
          canCancel: false,
          color: "#4B4B4B",
          backgroundColor: "#4B4B4B",
          height: 35,
          width: 35,
          loader: "bars",
          opacity: 0.3,
        });
        this.form.amount = this.summary.total;
        axios
          .post(
            api("subscription/negotiated/" + this.subscription.uuid),
            this.form
          )
          .then((response) => {
            loader.hide();
            if (response.data.status) {
              this.$toasted.global.all({
                message: "La demande de négociation a été enregistré",
              });
              setTimeout(() => {
                this.$router("/administration/subscriptions");
              }, 400);
            } else this.$toasted.global.error();
          })
          .catch((error) => {
            loader.hide();
            if (error.response.status === 422) {
              this.errors = error.response.data.errors;
            } else
              this.$toasted.global.error({
                message:
                  "Vous devez vous connecter pour procéder à cette opération",
              });
          });
      }
    },
    addBasket() {
      if (this.$store.state.upload.files.length > 0) {
        const loader = this.$loading.show({
          container: null,
          canCancel: false,
          color: "#4B4B4B",
          backgroundColor: "#4B4B4B",
          height: 35,
          width: 35,
          loader: "bars",
          opacity: 0.3,
        });
        let form = new FormData();
        this.$store.state.upload.files.map((file, key) => {
          form.append("files[" + key + "]", file);
        });
        axios
          .post(api("administration/file/upload"), form, {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          })
          .then((response) => {
            loader.hide();
            if (response.data.status) {
              this.files = response.data.files;
              let carts = this.$storage.getItem("carts");
              if (carts) {
                let data = JSON.parse(this.$storage.decryptString(carts));
                this.form.amount = this.summary.total;
                data.push({
                  product: this.form,
                  detail: this.summary,
                  files: this.files,
                  check: true,
                  uuids: this.$uuid(),
                  uuid: this.subscription.uuid,
                });
                //localStorage.setItem('carts', JSON.stringify(data));
                this.$storage.setItem(
                  "carts",
                  this.$storage.encryptString(JSON.stringify(data))
                );
                this.$toasted.global.all({
                  message: "Le produit est ajouté au panier",
                });
                setTimeout(() => {
                  window.location.href = "/pannier";
                }, 500);
              } else {
                const products = JSON.stringify([
                  {
                    product: this.form,
                    detail: this.summary,
                    files: this.files,
                    check: true,
                    uuids: this.$uuid(),
                    uuid: this.subscription.uuid,
                  },
                ]);
                this.$storage.setItem(
                  "carts",
                  this.$storage.encryptString(products)
                );
                this.$toasted.global.all({
                  message: "Le produit est ajouté au panier",
                });
                setTimeout(() => {
                  window.location.href = "/pannier";
                }, 500);
              }
            }
          })
          .catch(() => {
            loader.hide();
            this.$toasted.global.error({
              message: "Impossible d'ajouter le produit au panier",
            });
          });
      } else {
        let carts = this.$storage.getItem("carts");
        if (carts) {
          let data = JSON.parse(this.$storage.decryptString(carts));
          this.form.amount = this.summary.total;
          data.push({
            product: this.form,
            detail: this.summary,
            check: true,
            uuids: this.$uuid(),
            uuid: this.subscription.uuid,
          });
          //localStorage.setItem('carts', JSON.stringify(data));
          this.$storage.setItem(
            "carts",
            this.$storage.encryptString(JSON.stringify(data))
          );
          this.$toasted.global.all({
            message: "Le produit est ajouté au panier",
          });
          setTimeout(() => {
            window.location.href = "/pannier";
          }, 500);
        } else {
          const products = JSON.stringify([
            {
              product: this.form,
              detail: this.summary,
              check: true,
              uuids: this.$uuid(),
              uuid: this.subscription.uuid,
            },
          ]);
          this.$storage.setItem("carts", this.$storage.encryptString(products));
          this.$toasted.global.all({
            message: "Le produit est ajouté au panier",
          });
          setTimeout(() => {
            window.location.href = "/pannier";
          }, 500);
        }
      }
    },
    saveAssurance() {
      if (this.step === 3) {
        this.addBasket();
      } else {
        if (this.step === 1) {
          const loader = this.$loading.show({
            container: null,
            canCancel: false,
            color: "#4B4B4B",
            backgroundColor: "#4B4B4B",
            height: 35,
            width: 35,
            loader: "bars",
            opacity: 0.3,
          });
          this.loading = true;
          axios
            .post(api("assurances/automobile/save"), this.form)
            .then((response) => {
              this.loading = false;
              loader.hide();
              if (response.data.status) {
                this.errors = [];
                this.summary.amount = response.data.amount;
                this.summary.taxe = Math.round(
                  (this.summary.amount + this.summary.avenant) * 0.06
                );
                this.summary.total =
                  this.summary.amount +
                  this.summary.taxe +
                  this.summary.avenant;
                this.nextStep();
              } else this.$toasted.global.error();
            })
            .catch((error) => {
              loader.hide();
              if (error.response.status === 422) {
                this.errors = error.response.data.errors;
              }
              this.loading = false;
            });
        } else this.nextStep();
      }
    },

    getPuissance() {
      if (this.form.data.use_type !== "") {
        this.loading = true;
        //this.zone_section = [];
        axios
          .post(api("assurance-automobile/subscription"), {
            slug: "2-3-roue",
            use: this.form.data.use_type,
            state: "power",
          })
          .then((response) => {
            this.loading = false;
            this.puissance = response.data;
          })
          .catch((error) => {
            console.log(error);
            this.loading = false;
          });
      }
    },

    getDurations() {
      axios
        .post(api("assurance-automobile/subscription"), {
          state: "duration",
        })
        .then((response) => {
          this.loading = false;
          this.durations = response.data;
        })
        .catch((error) => {
          this.loading = false;
        });
    },
    changeType() {
      this.$emit("changeTypeAuto", 1);
    },
  },
};
</script>

<style scoped lang="scss">
input[type="checkbox"] {
  transform: scale(1.2);
}
.custom__badge_default {
  height: 50px;
  width: 50px;
  border-radius: 50%;
  border: 3px solid #d6d6dc;
  color: #d6d6dc;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 10px;
}
.step__voyage--item {
  display: grid;
  grid-template-columns: 1fr 240px;
  justify-content: center;
  align-items: center;
}
.custom__badge--active {
  background-color: #d39e0a;
  color: #ffffff;
  border: 3px solid #d39e0a !important;
}
.step__voyage {
  display: grid;
  grid-auto-flow: row;
  hr {
    border: 1px solid #d6d6dc;
    color: #d6d6dc;
    width: 310px;
  }
}
.form__label {
  color: #6e6b7b;
}
.badge__text {
  font-size: 19px;
  color: #6e6b7b;
}
.badge__text--active {
  color: #d39e0a;
}
.btn-default:focus,
.btn-default.focus {
  color: #fff;
  background-color: #b9b9c3;
  border-color: #b9b9c3;
}

.btn-default__cancel {
  color: #fff;
  background-color: #b9b9c3;
  border-color: #b9b9c3;
}

.btn-primary__save {
  color: #fff !important;
  background-color: #001e5f !important;
  border-color: #001e5f !important;
}
.delete__user {
  color: #e73d3e;
  cursor: pointer;
}
.user__add {
  color: #001e5f;
  cursor: pointer;
}
.section__information {
  display: grid;
  grid-template-columns: 150px 2fr 110px;
  align-items: baseline;
  .section__information-dote {
    border-bottom: 1px dotted #000000;
    align-self: center;
  }
  .section__information-price {
    justify-self: end;
    color: #000000;
    font-weight: bold;
  }
  .section__information-text {
    color: #6e6b7b;
  }
}

.section__amount {
  display: grid;
  grid-template-columns: 5fr 1fr;
  .section__amount-text {
    justify-self: end;
    color: #6e6b7b;
  }
  .section__amount-price {
    justify-self: end;
    color: #ea5455;
  }
}
.show__btn {
  display: none;
}

.section__neg-text {
  color: #002a85;
}

.section__neg {
  cursor: pointer;
}

.custom__badge-section {
  display: grid;
  grid-template-columns: 50px 50px 50px;
  justify-content: start;
  align-items: center;
  height: 100px;
  grid-gap: 10px;
}

.subscription__section {
  display: grid;
  grid-template-columns: 1fr 3fr;
  grid-gap: 30px;
}

.button__footer {
  display: grid;
  grid-template-columns: 200px 200px;
  justify-content: end;
}

@media only screen and (max-width: 500px) {
  .button__footer {
    display: grid;
    grid-template-columns: 1fr 1fr;
  }
}

@media only screen and (max-width: 870px) {
  .hide__subscription-section {
    display: none !important;
  }
  .subscription__section {
    display: grid;
    grid-template-columns: 1fr;
  }
}
@media only screen and (max-width: 992px) {
  .section__amount {
    grid-template-columns: 4fr 2fr;
  }
}
@media only screen and (max-width: 540px) {
  .show__btn {
    display: block;
  }
  .hide__on_mobile {
    display: none !important;
  }
  .hide__btn--large {
    display: none !important;
  }
  .page__header--info .page__header--info__icon {
    place-self: end;
    align-self: center;
  }
}
/*
    .surprime__section{
        display: grid;
        grid-template-columns: 110px 2fr 110px;
        align-items: baseline;
        .surprime__section-two{
            border-bottom: 1px dotted #000000;
        }
        .surprime__section-tree{
            justify-self: end;
            color: #000000;
            font-weight: bold;
        }
        .surprime__section-first{
            color: #6E6B7B;
        }
    }*/
.surprime__section {
  display: flex;
  flex-direction: row;
}
.surprime__section-two {
  flex-grow: 2;
  border-bottom: 1px solid;
}
.surprime__section-tree {
  flex-grow: 0;
}
</style>
